import { Typography } from '@mui/material';

type CarrinhoBbarTitle = {
    title: string;
    primary?: boolean;
};

export function CarrinhoBbarTitle({ title, primary }: CarrinhoBbarTitle) {
    return (
        <Typography
            sx={{
                fontWeight: 600,
                textTransform: 'uppercase',
                letterSpacing: 0.4,
                color: primary ? 'primary.main' : 'text.disabled',
                whiteSpace: 'nowrap',
                lineHeight: 1,
                fontSize: 10,
            }}
        >
            {title}
        </Typography>
    );
}
